// --- internal
import services from "./services";
// -----------------------------------------------------------------------------
export default {
  services
};
